import { render, staticRenderFns } from "./Sendmail.vue?vue&type=template&id=113c2d17&scoped=true&"
import script from "./Sendmail.vue?vue&type=script&lang=js&"
export * from "./Sendmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113c2d17",
  null
  
)

export default component.exports